<script>
  import { getContext, onMount } from 'svelte'
  import { fargetema } from '@/stores/fargetema'

  export let coords = []

  const animate = getContext('animate')
  const store = getContext('store')

  onMount(() => {
    let ctx = $store.canvas.getContext('2d')
    let raf
    function loop() {
      raf = requestAnimationFrame(loop)
      render()
    }

    function render() {
      if (coords.length > 0) {
        ctx.moveTo(...coords[0])
        ctx.beginPath()
        coords.forEach(([x, y]) => {
          ctx.lineTo(x, y)
          ctx.moveTo(x, y)
        })
        ctx.closePath()
        ctx.strokeStyle = $fargetema.pattern
        ctx.lineWidth = 0.5
        ctx.stroke()
      }
    }

    if (animate) {
      raf = requestAnimationFrame(loop)
    } else {
      raf = requestAnimationFrame(render)
    }

    return () => cancelAnimationFrame(raf)
  })
</script>
